import { render, staticRenderFns } from "./CustomBannerSwiper.vue?vue&type=template&id=41986273&scoped=true"
import script from "./CustomBannerSwiper.vue?vue&type=script&lang=js"
export * from "./CustomBannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./CustomBannerSwiper.vue?vue&type=style&index=0&id=41986273&prod&lang=less&scoped=true"
import style1 from "./CustomBannerSwiper.vue?vue&type=style&index=1&id=41986273&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41986273",
  null
  
)

export default component.exports